module.exports = __webpack_public_path__ + "img/jobs.f6ac1b2b.svg";